"use client";
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '../lib/utils';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import logoImg from '../assets/img/logo.png';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const pathname = location.pathname;

  const navItems = [
    { name: '首页', path: '/' },
    { name: 'GEO常见问题', path: '/faq' },
    { name: 'GEO优化服务', path: '/services' },
    { name: 'GEO成功案例', path: '/cases' },
    { name: 'GEO 知识库', path: '/knowledge' },
    { name: '联系我们', path: '/about' },
    { name: '合规声明', path: '/compliance' },
  ];

  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-[#ECECEC] h-20 flex items-center shadow-sm">
      <div className="max-w-[1400px] mx-auto w-full px-4 lg:px-6 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex flex-col items-start leading-none group">
          <img src={logoImg} alt="前排GEO" className="h-20 w-auto" />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-6 xl:gap-8">
          {navItems.map((item) => {
            const isActive =
              pathname === item.path ||
              (item.path !== '/' && pathname.startsWith(`${item.path}/`));
            return (
            <Link
              key={item.path}
              to={item.path}
              className={
                cn(
                  "relative py-7 text-sm font-semibold transition-colors duration-200 hover:text-[#D90000] after:absolute after:left-0 after:right-0 after:-bottom-px after:h-0.5 after:origin-center after:scale-x-0 after:bg-[#D90000] after:transition-transform",
                  isActive
                    ? "text-[#D90000] after:scale-x-100"
                    : "text-slate-600"
                )
              }
            >
              {item.name}
            </Link>
          )})}
        </div>

        {/* Action Button */}
        <div className="hidden lg:block">
          <Link to="/about" className="bg-[#D90000] text-white px-6 py-2.5 rounded-lg text-sm font-bold shadow-[0_8px_20px_rgba(217,0,0,0.22)] hover:bg-[#B80000] transition-all active:scale-95 inline-block">
            获取方案
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button className="lg:hidden p-2 text-slate-600" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden absolute top-20 left-0 w-full bg-white border-b border-slate-100 shadow-xl overflow-hidden"
          >
            <div className="flex flex-col p-6 gap-4">
              {navItems.map((item) => {
                const isActive =
                  pathname === item.path ||
                  (item.path !== '/' && pathname.startsWith(`${item.path}/`));
                return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={
                    cn(
                      "text-base font-semibold",
                      isActive ? "text-[#D90000]" : "text-slate-600"
                    )
                  }
                >
                  {item.name}
                </Link>
              )})}
              <Link to="/about"
                onClick={() => setIsMenuOpen(false)}
                className="mt-4 bg-[#D90000] hover:bg-[#B80000] text-white w-full py-3 rounded-lg font-bold text-center block transition-colors"
              >
                获取方案
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
